import styled from 'styled-components';
import { Card } from 'components/card/styled';
import { mediaLg, mediaMd, mediaSm, mediaXs } from 'theme/theme-helper-selectors';

export const ContentCard = styled(Card)`
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const Text = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    text-align: left;
`;

export const Name = styled.div`
    flex-shrink: 0;
    font-size: 32px;
    line-height: 36px;
    margin-bottom: 8px;
    font-weight: 500;

    @media (${mediaSm}) {
        font-size: 24px;
        line-height: 27px;
    }
`;

export const Description = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 21px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.6);
    overscroll-behavior: contain;

    ul {
        list-style-type: disc;
        padding: 0 0 0 40px;
    }

    &::-webkit-scrollbar {
        width: 16px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.2);
        border: 5px solid transparent;
        border-radius: 10px;
        background-clip: padding-box;
    }
`;

export const BottomContent = styled.div`
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    margin-top: 24px;
`;

export const Flip = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${({ theme }) => theme.palette.teal};
    font-size: 21px;
    line-height: 24px;
    font-weight: 500;
`;

export const ImageContainer = styled.div<{ background: string }>`
    height: 428px;
    background-image: ${({ background }) => `url(${background})`};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    margin: -48px -48px 40px -48px;

    @media (${mediaLg}) {
        height: 309px;
    }

    @media (${mediaMd}) {
        margin: -32px -32px 40px -32px;
        height: 292px;
    }

    @media (${mediaSm}) {
        height: 321px;
    }

    @media (${mediaXs}) {
        height: 343px;
    }
`;

export const Position = styled.div`
    font-size: 18px;
    line-height: 21px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 28px 0;
`;

export const Follow = styled.span`
    color: ${({ theme }) => theme.palette.white};
    font-weight: 500;
    font-size: 21px;
    line-height: 24px;

    a {
        word-break: break-all;
        overflow: hidden;
    }
`;

export const TalkContainer = styled.div`
    margin: 0 0 28px 0;
`;

export const Talk = styled.span<{ isGreen?: boolean }>`
    font-size: 24px;
    line-height: 27px;
    color: ${({ isGreen, theme }) => (isGreen ? theme.palette.teal : 'rgba(255, 255, 255, 0.6)')};
    font-weight: ${({ isGreen }) => (isGreen ? 500 : 400)};
`;
